import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addAdmin, loadingSet } from "../store/actions/userActions";
import Swal from "sweetalert2";
import LoadingComponent from "../components/LoadingComponent";

export default function RegisterPage() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { loading } = useSelector((state) => state.users);
	const [registerInput, setRegisterInput] = useState({
		email: "",
		username: "",
		phoneNumber: "",
		address: "",
		password: "",
	});

	const changeInputRegister = (e) => {
		const { name, value } = e.target;
		setRegisterInput({ ...registerInput, [name]: value });
	};

	const submitHandler = (e) => {
		e.preventDefault();

		dispatch(addAdmin(registerInput))
			.then(() => {
				Swal.fire({
					position: "top-end",
					icon: "success",
					title: "new admin successfully added",
					showConfirmButton: false,
					timer: 1000,
				});
				navigate("/");
			})
			.catch((err) => {
				Swal.fire({
					icon: "error",
					title: "Error",
					text: err,
				});
			})
			.finally(() => {
				dispatch(loadingSet(false));
			});
	};

	return (
		<>
			{loading ? (
				<LoadingComponent />
			) : (
				<div>
					<h2>Register New Admin</h2>
					<h5 className="mt-4">Personal Information</h5>
					<p className="text-muted mb-0">Use a permanent address where you can receive mail.</p>
					<form onSubmit={submitHandler}>
						<hr className="mt-0" />
						<div className="mb-3 row">
							<label className="col-sm-2 col-form-label">Username</label>
							<div className="col-sm-10">
								<input
									type="text"
									name="username"
									className="form-control"
									value={registerInput.username}
									onChange={changeInputRegister}
								/>
							</div>
						</div>
						<hr />
						<div className="mb-3 row">
							<label className="col-sm-2 col-form-label">Email Address</label>
							<div className="col-sm-10">
								<input
									type="text"
									name="email"
									className="form-control"
									value={registerInput.email}
									onChange={changeInputRegister}
								/>
							</div>
						</div>
						<hr />
						<div className="mb-3 row">
							<label className="col-sm-2 col-form-label">Phone Number</label>
							<div className="col-sm-10">
								<input
									type="text"
									name="phoneNumber"
									className="form-control"
									value={registerInput.phoneNumber}
									onChange={changeInputRegister}
								/>
							</div>
						</div>
						<hr />
						<div className="mb-3 row">
							<label className="col-sm-2 col-form-label">Address</label>
							<div className="col-sm-10">
								<input
									type="text"
									name="address"
									className="form-control"
									value={registerInput.address}
									onChange={changeInputRegister}
								/>
							</div>
						</div>
						<hr />
						<div className="mb-3 row">
							<label className="col-sm-2 col-form-label">Password</label>
							<div className="col-sm-10">
								<input
									type="password"
									name="password"
									className="form-control"
									value={registerInput.password}
									onChange={changeInputRegister}
								/>
							</div>
						</div>
						<hr />
						<div className="d-flex justify-content-end">
							<button type="submit" className="btn btn-primary">
								Save
							</button>
							<button onClick={() => navigate("/")} className="btn btn-danger ms-2">
								Cancel
							</button>
						</div>
					</form>
				</div>
			)}
		</>
	);
}
